import { render, staticRenderFns } from "./CursorCoordinates.vue?vue&type=template&id=37294f7c&"
import script from "./CursorCoordinates.vue?vue&type=script&lang=ts&"
export * from "./CursorCoordinates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports